var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "RealTimeQuality" },
    [
      _c(
        "ul",
        _vm._l(_vm.memberList, function (item, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "_item",
              class: { activeTab: _vm.active === index },
              on: {
                click: function ($event) {
                  return _vm.activeTab(index)
                },
              },
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(" " + _vm._s(item.userName) + " "),
              ]),
              _c("div", { staticClass: "name" }, [
                _vm._v(" " + _vm._s(item.pushUid) + " "),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "帧率", name: "Frame" } }),
          _c("el-tab-pane", { attrs: { label: "码率", name: "Code" } }),
          _c("el-tab-pane", { attrs: { label: "丢包率", name: "Packet" } }),
          _c("el-tab-pane", { attrs: { label: "时延", name: "delay" } }),
        ],
        1
      ),
      _c("div", { attrs: { id: "echart" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }